import { ApiResponse, TokenData, BuyingInfluence } from '../models';
import * as http from './http';
import ApiService from './service';

export class BuyingInfluenceService extends ApiService {
  public async loadAllBuyingInfluence() {
    const url = `${this.apiDomain}/api/buying-influence`;

    const resposne = await http.get<ApiResponse<BuyingInfluence[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createBuyingInfluence(data: BuyingInfluence) {
    const url = `${this.apiDomain}/api/buying-influence`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateBuyingInfluence(data: BuyingInfluence, id?: string) {
    const url = `${this.apiDomain}/api/buying-influence/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteBuyingInfluence(id?: string) {
    const url = `${this.apiDomain}/api/buying-influence/${id}`;

    const response = await http.remove<ApiResponse<BuyingInfluence>>(
      url,
      this.store
    );
    return response.data;
  }
}
